import httpService from '@/utils/request'
import { contextPath } from '@/config/'

export const getSpiderByIdApi = (params) => {
  return httpService({
    url: contextPath + '/spider/item',
    method: 'get',
    params
  })
}

export const getSpiderApiByIdApi = (params) => {
  return httpService({
    url: contextPath + '/spider/api/item',
    method: 'get',
    params
  })
}
export const getSpiderDocByIdApi = (params) => {
  return httpService({
    url: contextPath + '/spider/doc/item',
    method: 'get',
    params
  })
}

export const getSpiderTwitterByIdApi = (params) => {
  return httpService({
    url: contextPath + '/spider/twitter/item',
    method: 'get',
    params
  })
}

export const addSpiderItemApi = (data) => {
  return httpService({
    url: contextPath + '/spider/item',
    method: 'post',
    data
  })
}

// 添加api
export const addSpiderApiItem = (data) => {
  return httpService({
    url: contextPath + '/spider/api/item',
    method: 'post',
    data
  })
}

// 添加文档
export const addSpiderDocumentItem = (data) => {
  return httpService({
    url: contextPath + '/spider/doc/item',
    method: 'post',
    data
  })
}

export const addSpiderTwitterItemApi = (data) => {
  return httpService({
    url: contextPath + '/spider/twitter/item',
    method: 'post',
    data
  })
}

export const updateSpiderItemApi = (data) => {
  return httpService({
    url: contextPath + '/spider/item',
    method: 'put',
    data
  })
}

export const updateSpiderApiItemApi = (data) => {
  return httpService({
    url: contextPath + '/spider/api/item',
    method: 'put',
    data
  })
}

export const updateSpiderDocItemApi = (data) => {
  return httpService({
    url: contextPath + '/spider/doc/item',
    method: 'put',
    data
  })
}

export const updateSpiderTwitterItemApi = (data) => {
  return httpService({
    url: contextPath + '/spider/twitter/item',
    method: 'put',
    data
  })
}

export const queryTagListApi = (params) => {
  return httpService({
    url: contextPath + '/spider/tag/info',
    method: 'get',
    params
  })
}

export const queryCountryOptionsApi = (params) => {
  return httpService({
    url: contextPath + '/common/country/info ',
    method: 'get',
    params
  })
}

export const testSpiderApi = (data) => {
  return httpService({
    url: contextPath + '/spider/item/parseHtml',
    method: 'post',
    data
  })
}

export const getAvatarApi = (params) => {
  return httpService({
    url: contextPath + '/spider/item/headImage',
    method: 'get',
    params
  })
}

export const queryPageTemplate = (params) => {
  return httpService({
    url: contextPath + '/page-template/queryPageTemplate',
    method: 'get',
    params
  })
}


export const execAccountUrlApi = params => {
  return httpService({
    url: contextPath + '/spider/api/generateWeChatId',
    method: 'get',
    params
  })
}